
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class BreadCrumb extends Vue {

  get breadcrumbs(): { label: string; path: string }[] {
    const visibleRoutes = this.$route.matched.filter(
      (route) =>
        route.meta?.labels?.length &&
        !route.meta?.hiddenOnNavigation &&
        route.path !== '/admin' && route.path !== '/nao-autorizado',
    );

    const breadcrumbs = visibleRoutes.map((route) => ({
      label: (route.meta?.labels ?? []).join(' '),
      path: route.path,
    }));

    return breadcrumbs;
  }
}
